import PolyMesh from '../model/PolyMesh';
import ObjectsByName from '../../generic/container/ObjectsByName';

export default function applyFunctionToPolyMap(polyMesh, applyToPolyMapFunction, additionalArguments) {
  const args = additionalArguments || {};

  const resultMesh = new PolyMesh(polyMesh);
  resultMesh.positions = applyToPolyMapFunction(resultMesh.positions, 'positions', args);
  if (resultMesh.normalMap) resultMesh.normalMap = applyToPolyMapFunction(resultMesh.normalMap, 'normalMap', args);

  const uvMaps = new ObjectsByName();
  for (let i = 0; i < polyMesh.uvMaps.length; i++) {
    const name = polyMesh.uvMaps.namesByIndex[i];
    const uvMap = applyToPolyMapFunction(polyMesh.uvMaps.byName[name], name, args);
    uvMaps.set(name, uvMap);
  }

  resultMesh.uvMaps = uvMaps;
  resultMesh.faceRangeOffsets = resultMesh.positions.faceRangeOffsets;

  return resultMesh;
};



// WEBPACK FOOTER //
// ./src/polyMesh/geometric/operator/applyFunctionToPolyMap.js